import { Alert, Button, Modal, ModalSection } from '@monash/portal-react';
import DateAndTime from '../date-and-time/DateAndTime';
import c from './schedule-publish-modal.module.scss';
import InlineErrorMessage from '../inline-error-message/InlineErrorMessage';
import { useEffect } from 'react';
import { getErrorMessage } from './get-error-message';
import { useFormContext, useWatch } from 'react-hook-form';

const SchedulePublishModal = ({
  isOpen,
  onClose,
  onPublish,
  onRemoveSchedule,
  submitError,
  title,
  dateFieldName,
  timeFieldName,
  isScheduled,
  isScheduling,
  isRemoving,
  disabled,
}) => {
  const {
    getValues,
    trigger,
    formState: { errors, touchedFields },
  } = useFormContext();

  const publishDate = useWatch({ name: dateFieldName });

  // Since publishTime is the field with the validate function
  // publishDate needs to be triggered manually
  useEffect(() => {
    if (touchedFields[dateFieldName] || touchedFields[timeFieldName])
      trigger(timeFieldName);
  }, [publishDate]);

  return (
    <Modal open={isOpen} onClose={onClose}>
      <ModalSection title={title}>
        <DateAndTime
          label="Select date and time"
          names={{ date: dateFieldName, time: timeFieldName }}
          disabled={disabled}
          validateTime={() => {
            const [publishDate, publishTime] = getValues([
              dateFieldName,
              timeFieldName,
            ]);

            if (isOpen) {
              const err = getErrorMessage({
                publishDate,
                publishTime,
              });
              return err;
            }
          }}
        />

        {errors?.[timeFieldName] && (
          <InlineErrorMessage
            className={c.error}
            message={errors[timeFieldName].message}
          />
        )}
      </ModalSection>
      <div className={c.actionsContainer}>
        {submitError && <Alert type="error">{submitError}</Alert>}

        <div className={c.actionsButtons}>
          <span>
            {isScheduled && (
              <Button
                className={c.removeSchedule}
                onClick={onRemoveSchedule}
                size="small"
                variant="text"
                loading={isRemoving}
                disabled={disabled}
              >
                Remove schedule
              </Button>
            )}
          </span>

          <Button
            onClick={onPublish}
            size="large"
            loading={isScheduling}
            disabled={disabled}
          >
            Schedule publish
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SchedulePublishModal;
